<template>
  <dashboard-page
    title="Acompanhamento"
    subtitle="Serviços em andamento"
  >
    <template #actions>
      <base-button
        @click="showFilters = !showFilters"
        icon
        :type="showFilters ? 'danger' : 'primary'"
        size="sm"
      >
        <span class="btn-inner--icon">
          <i class="fas fa-filter"></i>
        </span>
      </base-button>
    </template>
    <div class="content">

    <b-modal v-model="showFilters" :showClose="true" size="xl" no-close-on-esc>
      <b-row>
        <b-col cols="12">
          <filter-select-service-monitor
            :selectOptions="selectOptions"
            @selectedClients="setSelectFilterOptions"
            :visible="showFilters"
            :selectOptionsToPreserve="selectOptionsToPreserve"
            :resetFilter="rebootFilters"
            @rebootedFilter="setRebootFilter"
          />
        </b-col>
      </b-row>

      <hr />
      <b-row v-if="checkboxOptionsCategories.length > 0">
        <b-col cols="12">
          <filter-checkbox-service-monitor
            :checkboxOptionsProducts="checkboxOptionsProducts"
            :checkboxOptionsCategories="checkboxOptionsCategories"
            :serviceOptionsToPreserve="serviceOptionsToPreserve"
            @selectedServices="setServicesFilterOptions"
            :visible="showFilters"
            :resetFilter="rebootFilters"
            @rebootedFilter="setRebootFilter"
            :objectName="'Serviços'"
            :class="`my-0 py-0`"
          />
        </b-col>
      </b-row>

      <template #footer>
        <b-row style="margin-top: 5px">
          <b-col cols="6">
            <base-button @click="clearFilters()" type="error" size="sm"
              >Limpar</base-button
            >
          </b-col>

          <b-col cols="6">
            <base-button
              @click="showFilters = !showFilters"
              type="primary"
              size="sm"
              >Aplicar</base-button
            >
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <b-container fluid>
      <div>
        <b-modal v-model="openMetadataModal" class="" :size="'xl'">
          <template #modal-header class="mt-0">
            <h2 align-v="start" class="card-header w-100 mt-0">
              Editar Metadado
            </h2>
          </template>

          <metadataModal
            :metadataType="metadataType"
            :xfields="this.selectedBillServiceCard.serviceXfields"
            :bill_id="new Number(this.selectedBillServiceCard.bid)"
            :uuid="this.selectedBillServiceCard.uuid"
            :uuid_ref="'bill'"
            :hash="this.selectedBillServiceCard.metadata.hash"
            :info="this.selectedBillServiceCard.info"
            :title="metadataFormTitle"
            :keepHistory="metadataKeepHistory"
            @close-modal="metadataUpdated"
            class="mt-0"
          />
        </b-modal>

        <card>
          <div>
            <el-table
              v-loading="tableLoading"
              :data="filteredPendentBillServices"
              row-key="id"
              size="small"
              header-row-class-name="thead-light"
              height="768"
            >
              <el-table-column width="auto" label="Nome" minWidth="250">
                <div slot-scope="{ $index, row }" class="d-flex"></div>
              </el-table-column>

              <el-table-column
                v-for="column in filteredServicesTableColumns"
                :key="column.pid"
                v-bind="column"
              >
                <div v-if="row[column.pid]" slot-scope="{ $index, row }">
                  <div
                    v-for="(card, bpid) in row[column.pid]"
                    :key="card.bpid"
                    v-bind="card"
                  >
                    <b-list-group flush data-toggle="checklist">
                      <b-list-group-item
                        class="checklist-entry flex-column align-items-start py-0 px-0"
                      >
                        <div
                          class="checklist-item"
                          @click="
                            handleView(
                              $index,
                              column.pid,
                              bpid,
                              'ServiceStatus'
                            )
                          "
                          style="cursor: pointer"
                          :class="{
                            'checklist-item-checked':
                              card.metadata.type == 'ServiceStatus' &&
                              card.metadata.value == 'finished',
                            [`checklist-item-${
                              serviceStatusTypes[card.metadata.value || 'new']
                            }`]: true,
                            [card.metadata.value || 'light']: true,
                          }"
                          title="ver detalhes"
                        >
                          <div class="checklist-info">
                            <h5 class="checklist-title mb-0">
                              {{ card.title }}
                            </h5>
                            <small>
                              <div v-if="card.metadata.type == 'ServiceStatus'">
                                <span>{{
                                  card.metadata.options[card.metadata.value]
                                }}</span>
                              </div>
                              <div v-else>novo</div>

                              <span
                                v-if="card.metadata.date"
                                :title="` ${card.metadata.message}`"
                              >
                                <span class="d-block">
                                  <i class="fas fa-clock"></i>
                                  {{
                                    new Date(
                                      card.metadata.date
                                    ).toLocaleDateString()
                                  }}
                                </span>
                                <span class="d-block">
                                  <i class="fas fa-user"></i>
                                  {{ card.metadata.user.name }}
                                </span>
                              </span>
                            </small>
                          </div>
                          <!-- <div>
                            <b-form-checkbox v-model="item.done" :class="`custom-checkbox-${item.checkType}`" />
                          </div> -->
                        </div>
                      </b-list-group-item>
                    </b-list-group>
                    <!-- Contratação: {{ new Date(card.start_date).toLocaleDateString() }}
                    <br>
                    Valor: {{ (card.total_price).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}
                    <br> -->

                    <br />
                  </div>
                </div>
              </el-table-column>
            </el-table>
          </div>

          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          ></div>
        </card>
      </div>
    </b-container>
  </div>
  </dashboard-page>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { isMobile } from '@/store/utils/general'
import Card from '@/components/Cards/Card.vue'
import BaseHeader from '@/components/BaseHeader.vue'
import { Table, TableColumn, Select, Option } from 'element-ui'
import { BasePagination } from '@/components'
import metadataModal from '@/views/Clients/components/metadataModal.vue'
import { Modal } from '@/components'
import FilterSelectServiceMonitor from './FilterSelectServiceMonitor.vue'
import FilterCheckboxServiceMonitor from './FilterCheckboxServiceMonitor.vue'
import { json } from 'd3'

export default {
  name: 'ServiceMonitor',

  components: {
    Card,
    BaseHeader,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    metadataModal,
    FilterSelectServiceMonitor,
    FilterCheckboxServiceMonitor,
  },

  data() {
    return {
      servicesTableColumns: [],
      products: [],
      productsMap: [],
      openMetadataModal: false,
      tableLoading: false,
      pendentBillServices: [],
      pendentBillServicesCards: [],
      mobileMode: isMobile(),
      selectedBillServiceCard: { metadata: { hash: '' } },
      infoMetadata: '',
      metadataFormTitle: 'Status do serviço',
      metadataKeepHistory: true,
      metadataType: 'ServiceStatus',
      serviceStatusTypes: {
        new: 'light',
        doing: 'info',
        analises: 'danger',
        done: 'primary',
        finished: 'success',
      },
      showFilters: false,
      rebootFilters: false,
      selectFilterOptions: [],
      checkboxServiceOptions: [],
      serviceOptionsToPreserve: [],
      selectOptionsToPreserve: [],
    }
  },

  computed: {
    checkboxOptionsCategories() {
      var vm = this
      var options = this.products
        .map(function (value, index) {
          if (vm.checkboxOptionsProducts.includes(value.n)) {
            return { category: value.n[0], service: value.n }
          }
        })
        .filter((el) => el != undefined)

      return Array.from(this.groupBy(options, (el) => el.category))
    },

    selectOptions() {
      if (this.selectFilterOptions.length > 0) {
        this.selectOptionsToPreserve = this.selectFilterOptions
      }

      return this.pendentBillServicesCards
        .map(function (value, index) {
          return value.client_name
        })
        .sort()
    },

    checkboxOptionsProducts() {
      if (this.checkboxServiceOptions.length > 0) {
        this.serviceOptionsToPreserve = this.checkboxServiceOptions
      }

      var options = this.servicesTableColumns
        .map(function (value, index) {
          return value.label
        })
        .sort()
      return [...new Set(options)]
    },

    filteredPendentBillServices() {
      if (this.selectFilterOptions.length > 0) {
        var vm = this
        var filter = this.pendentBillServicesCards.filter(function (val, idx) {
          var name = Object.values(val)
          name = name[name.length - 1]
          if (vm.selectFilterOptions.includes(name)) {
            return val
          }
        })
        return filter
      }
      return this.pendentBillServicesCards
    },

    filteredServicesTableColumns() {
      if (this.checkboxServiceOptions.length > 0) {
        var vm = this
        var filter = this.servicesTableColumns.filter(function (val, idx) {
          var label = val.label
          if (vm.checkboxServiceOptions.includes(label)) {
            return val
          }
        })
        return filter.sort((prev, curr) => {
          return prev.label && curr.label && prev.label > curr.label
        })
      } else {
        return this.servicesTableColumns
      }
    },
  },

  methods: {
    ...mapActions('client', ['getAllClients', 'getServicesPendecies']),

    ...mapActions('product', ['loadProducts', 'loadProductsMap']),

    clearFilters() {
      this.rebootFilters = true
    },

    setRebootFilter(filter) {
      this.rebootFilters = false
      this.selectFilterOptions = []
      this.checkboxServiceOptions = []
      this.serviceOptionsToPreserve = []
      this.selectOptionsToPreserve = []
    },

    handleView(rowId, pid, bpid, type) {
      this.metadataType = type
      this.selectedBillServiceCard =
        this.filteredPendentBillServices[rowId][pid][bpid]
      this.selectedBillServiceCard.rowId = rowId
      this.selectedBillServiceCard.pid = pid
      this.selectedBillServiceCard.bpid = bpid
      this.selectedBillServiceCard.metadata.hash =
        this.filteredPendentBillServices[rowId][pid][bpid]['hash']
      // console.log('value ',this.selectedBillServiceCard.metadata.value)
      // console.log(this.pendentBillServicesCards[rowId][pid][bpid],',,,,,,,,,,,,,,,,',rowId,pid,bpid)
      this.openMetadataModal = true
      // console.log('value ',this.selectedBillServiceCard.metadata.value)
      // this.infoMetadata += '<br><b>Status: </b> ' + (this.selectedBillServiceCard.status ? this.selectedBillServiceCard.status : '--')
    },

    async populateServicesTableCards() {
      const vm = this
      let columns = []
      this.pendentBillServicesCards = []

      this.pendentBillServices.forEach((bill) => {
        if (bill.services != undefined) {
          bill.services.forEach((service) => {
            if (columns[service.pid] == undefined) {
              columns[service.pid] = {
                pid: service.pid,
                label: service.product.name,
                minWidth: 200 /* sortable: true */,
              }
            }

            //feed services Data
            if (vm.pendentBillServicesCards[bill.Client.id] == undefined) {
              vm.pendentBillServicesCards[bill.Client.id] = {
                client_name: bill.Client.name,
              }
            }

            if (
              vm.pendentBillServicesCards[bill.Client.id][service.pid] ==
              undefined
            ) {
              vm.pendentBillServicesCards[bill.Client.id][service.pid] = {}
            }

            vm.pendentBillServicesCards[bill.Client.id][service.pid][
              service.bpid
            ] = this.createServiceCard(bill, service)
          })
        }
      })

      columns = Object.values(columns).sort((prev, curr) => {
        return prev.label && curr.label && prev.label > curr.label
      })

      this.servicesTableColumns = [...Object.values(columns)]
      // console.log('pendentBillServices', this.pendentBillServices)
      this.pendentBillServicesCards = Object.values(
        this.pendentBillServicesCards
      )
      // console.log('pendentBillServicesCards', (this.pendentBillServicesCards))
      // console.log('servicesTableColumns', this.servicesTableColumns)
    },

    createServiceCard(bill, service) {
      let card = service
      card.bid = bill.id
      card.uuid = bill.uuid
      card.cid = bill.Client.id

      card.metadata = this.listMetadata(bill.metadata, service.bpid) || {}
      card.title = bill.Client.name
      card.info = ''
      card.info = '<b>Cliente: </b> ' + bill.Client.name
      card.info += '<br><b>Serviço: </b> ' + service.product.name
      card.info +=
        '<br><b>Contratação: </b> ' +
        new Date(service.start_date).toLocaleDateString()
      card.info +=
        '<br><b>Valor: </b> ' +
        service.total_price.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
      card.serviceXfields = {
        type: this.metadataType,
        history: [],
        date: new Date().toISOString(),
        user: {},
        data: {
          amount: card.amount,
          bid: card.bid,
          bpid: card.bpid,
          pid: card.pid,
        },
        title: card.metadata.title,
        value: card.metadata.value,
        message: card.metadata.message,
      }
      // console.log('card 2',bill.metadata)
      // console.log('card 3',card.metadata)
      return card
    },

    listMetadata(metadata, bpid) {
      let serviceMetadata = {}
      metadata.forEach((meta, metakey) => {
        try {
          let metadataxfields = {}
          metadataxfields = JSON.parse(meta.xfields)
          if (metadataxfields.data.bpid == bpid) {
            serviceMetadata = metadataxfields
            serviceMetadata.hash = meta.hash
          }
        } catch (error) {}
      })
      return serviceMetadata
    },

    metadataUpdated(data) {
      let card = JSON.parse(JSON.stringify(this.selectedBillServiceCard))
      card.serviceXfields = JSON.parse(data.xfields)
      card.hash = data.hash
      card.metadata = JSON.parse(data.xfields)
      this.filteredPendentBillServices[card.rowId][card.pid][card.bpid] = card
      this.openMetadataModal = false
    },

    setSelectFilterOptions(opts) {
      this.selectFilterOptions = opts
    },
    setServicesFilterOptions(opts) {
      this.checkboxServiceOptions = opts
    },

    groupBy(list, keyGetter) {
      const map = new Map()
      list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)

        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })
      return map
    },
  },

  created() {
    if (process.env.NODE_ENV != 'production') {
      window.jdebug = this
    }
  },

  async mounted() {
    await this.loadProductsMap()
    await this.loadProducts().then((rsp) => {
      this.products = rsp.list
      this.loading = false
    })

    await this.getAllClients()
    // await this.populateTable()
    // await this.createFuseSearch(["name", "cpf"])
    await this.getServicesPendecies().then((rsp) => {
      this.pendentBillServices = rsp.pendent_services
      this.populateServicesTableCards()
    })
  },
}
</script>
